<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Great Escape Forger</h1>
<p class="subtitle">The Work of Carl Holmstrom – POW#221<br/> An Artist in Stalag Luft III</p>
<p class="author">Susan Holmstrom Kohnowich</p>
<p class="aff">Assistance with manuscript preparation by Marilyn Jeffers Walton</p>
<div class="img_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?0c3d7fa6